<template>
  <div v-if="isShowReleaseNotes"  class="releaseCard" @mouseenter="onHover(true)" @mouseleave="onHover(false)"
    :style="{ left:  hideSidebar || isSidebarShow ? '24px' : isCollapseSideBar ? '74px' : '240px' }">
    <div @click="reloadWindow" class="flex items-center gap-1">
      <div class="releaseIcon">{{ iconsList[randomIndex] }}</div>
        <div v-show="!isHovered" class="'w-full font-semibold content">{{ textContent }}</div>
        <div v-show="isHovered" class="w-full font-semibold content">{{ textContent }}</div>
    </div>

    <div @click="closeWidget" class="closeIcon">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
        aria-hidden="true" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17 7L7 17M7 7l10 10"></path>
      </svg>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'


import { AppRelease } from '../../../models';
import { checkForNewReleases, storeReleaseDate, getStoredReleaseDate } from '../../../util/app-release';
import moment from 'moment'
import { notificationIntervals } from '../../../types/app_release'
import { customLogger } from '../../../plugins/sentry/customLogger';

let checkIntervalId: NodeJS.Timeout | null = null;
const initialTimeout: NodeJS.Timeout | null = null;
const iconsList = ['🚀', '🌟', '💫', '✨', '🆕', '🙂', '👋']



export default defineComponent({
  props: {
    user: Object,
  },
  data() {
    return {
      isShowReleaseNotes: false,
      initialLoad: true,
      iconsList,
      textContent: 'App update is available!',
      isHovered: false,
      randomIndex: Math.floor(Math.random() * iconsList.length),
      isSidebarShow: false,
    }
  },
  async mounted() {
    const isIgnored = await AppRelease.isIgnored(this.user?.companyId,this.user?.id)
    if(!isIgnored){
      this.registerAppReleases();
      this.setupRealTimeListener();
    }
    else{
      this.isShowReleaseNotes = false;
    }
  },
  unmounted() {
    if (checkIntervalId) clearInterval(checkIntervalId);
    if (initialTimeout) clearTimeout(initialTimeout);
  },
  methods: {
    async registerAppReleases() {
      this.setupInterval();

    },
    async setupRealTimeListener() {
      const lastReleaseDate = getStoredReleaseDate()
      const hotFixesRef = AppRelease.listenToHotFixes(lastReleaseDate);
      hotFixesRef.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added' && !this.initialLoad) {
            this.isShowReleaseNotes = true;
            this.randomIndex = Math.floor(Math.random() * iconsList.length)
            this.setupInterval();
          }
        });
        this.initialLoad = false;
      });
    },
    reloadWindow(e: Event) {
      e.stopImmediatePropagation();
      this.metricsToSentry('App_Release_Refreshed')
      this.closeWidget();
      window.location.reload()
    },
    closeWidget() {
      this.isShowReleaseNotes = false;
      storeReleaseDate(moment())
      this.setupInterval();
      this.metricsToSentry('App_Release_Closed')
    },
    setupInterval() {
      if (checkIntervalId) clearInterval(checkIntervalId);
      checkIntervalId = setInterval(() => {
        checkForNewReleases().then((release) => {
          if (release) {
            this.isShowReleaseNotes = true;
            this.randomIndex = Math.floor(Math.random() * iconsList.length)
          }
        });
      }, notificationIntervals.releaseCheckInterval);
    },
    onHover(state: boolean) {
      this.isHovered = state;
      this.textContent = state ? 'Click to refresh!' : 'App update is available!';
    },
    metricsToSentry(type:string){
      customLogger({message: type, level: 'info', tags: {
        user_id: this.user?.id,
        company_id: this.user?.companyId,
        locationId: this.$route.params.location_id ?? ''
      }})
    }
  },
  computed: {
    isCollapseSideBar() {
      return this.$store.getters.getManualCollapseSidebar
    },
    hideSidebar() {
      return this.$route.meta?.hideSideBar
    },
  },
  watch: {
    '$route': function() {
      setTimeout(() => {
        this.isSidebarShow = document.querySelector('#sidebar-v2') ? false : true
      }, 100)
    }
  }
})
</script>
<style scoped lang="scss">
.releaseCard {
  position: fixed;
  bottom: 14px;
  background: #2970FF;
  display: flex;
  box-shadow: 0 25px 25px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  z-index: 3;
  color: #fff;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  text-align: left;
  align-items: center;
  gap: 4px;
  padding: 8px;
  height: 36px;
  cursor: pointer;
  min-width: 175px;

  .releaseIcon {
    font-size: 15px;
  }

  .closeIcon {
    position: absolute;
    right: -8px;
    top: -8px;
    border: 1px solid #F2F4F7;
    box-shadow: 0px 1px 2px 0px #1018280D;
    border-radius: 50%;
    display: flex;
    align-items: center;
    background: #fff;
    width: 18px;
    height: 18px;
    cursor: pointer;
    color: #344054;
  }

  .content{
    opacity: 0;
      animation: fadeIn 0.3s ease-in forwards;
  }

  @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

}
</style>
